<footer class="footer text-center text-sm-start"> 
</footer>
